import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import { createRef } from 'react';

class InlineConfirm extends Component {
  cancelButtonRef: any;

  constructor(props) {
    super(props);

    this.cancelButtonRef = createRef();
  }

  handleOnCancel = () => {
    this.cancelButtonRef.current.click();

    this.props.onAction('cancel');
  }

  handleOnConfirm = () => {
    this.cancelButtonRef.current.click();

    this.props.onAction('confirm');
  }

  render() {
    const { title, text, confirmOkText, confirmCancelText } = this.props;

    return (
      <div className="popover-popconfirm">
        { !!title && <h3>{ title }</h3> }
        <div className="popconfirm inline-variant">
          <div className="popconfirm-content d-inline-block mr-3">
            { text }

            { ' ' }

            <Button type="button"
                variant="secondary"
                size="sm"
                onClick={ this.handleOnCancel.bind(this) }
              >
              { confirmCancelText || 'No' }
            </Button>
            <Button type="button"
                variant="primary"
                size="sm"
                className="ml-2"
                onClick={ this.handleOnConfirm.bind(this) }
              >
              { confirmOkText || 'Sí' }
            </Button>

            <Button type="button"
              bsPrefix="d-none d-none"
              ref={ this.cancelButtonRef }
            >
              Dismiss
            </Button>
          </div>
        </div>
      </div>
    )
  }
}

export default InlineConfirm;